export default __webpack_public_path__ + "static/media/home_carousel_3.306294a7.jpg";